import React from 'react'

import { mediaQueries } from '@centivo/react-components'
import styled from 'styled-components'

import logo from 'assets/images/centivo-logo-new.svg'

type LogoProps = Omit<React.ComponentPropsWithoutRef<'img'>, 'src'>

const Image = styled.img`
  height: 1.5rem;
`

const LinkWrapper = styled.div`
  flex-grow: 1;
  text-align: left;

  &:only-child {
    text-align: center;

    & ${Image} {
      height: 4rem;

      @media ${mediaQueries.mobile} {
        height: 3.5rem;
      }
    }
  }

  &:focus {
    outline: none;
  }
`

export const Logo: React.FC<LogoProps> = ({
  alt = 'Centivo',
  'aria-label': ariaLabel = 'Centivo logo',
  ...props
}) => (
  <LinkWrapper>
    <a href="/">
      <Image src={logo} alt={alt} aria-label={ariaLabel} {...props} />
    </a>
  </LinkWrapper>
)
